var planningApp = angular.module('planning', ['commons.app']);
